import React, { ForwardedRef } from 'react';
import ReactSelect, {
  GroupBase,
  mergeStyles,
  Props,
  SelectInstance,
} from 'react-select';
import { hofForwardRef } from '../../../utils/types';
import {
  BasicSingleValue,
  EmptyComponent,
  getDefaultStyles,
} from './SelectUtils';
import { MENU_LIST_CLASSNAME } from './utils';
import {
  FloatingLayerProvider,
  useFloatingLayerContext,
} from '../../FloatingManager';

/*
 * This component should be used when we have a plain dropdown with static
 * options and there is no fetching logic behind
 */
export default hofForwardRef(
  <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
  >(
    {
      styles,
      components,
      menuPlacement,
      placeholder,
      ...props
    }: Props<Option, IsMulti, Group>,
    ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
  ) => {
    const zIndex = useFloatingLayerContext();

    const selectStyles = mergeStyles(
      getDefaultStyles<Option, IsMulti, Group>(zIndex),
      styles,
    );

    return (
      <FloatingLayerProvider>
        <ReactSelect
          {...props}
          ref={ref}
          menuPlacement={menuPlacement || 'auto'}
          placeholder={placeholder || ''}
          styles={selectStyles}
          isClearable={props?.isClearable ?? true}
          noOptionsMessage={() =>
            props.isLoading ? 'Loading...' : 'No options'
          }
          classNames={{
            menuList: () => MENU_LIST_CLASSNAME,
          }}
          components={{
            MultiValueRemove: EmptyComponent,
            DropdownIndicator: EmptyComponent,
            IndicatorSeparator: EmptyComponent,
            ClearIndicator: EmptyComponent,
            LoadingIndicator: EmptyComponent,
            SingleValue: BasicSingleValue,
            ...components,
          }}
        />
      </FloatingLayerProvider>
    );
  },
);
